import { render, staticRenderFns } from "./pay-type.vue?vue&type=template&id=492de558&scoped=true&"
import script from "./pay-type.vue?vue&type=script&lang=js&"
export * from "./pay-type.vue?vue&type=script&lang=js&"
import style0 from "./pay-type.vue?vue&type=style&index=0&id=492de558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492de558",
  null
  
)

export default component.exports